import { createContext, useState } from "react";

export const FinancialDetailsContext = createContext();

const FinancialDetailsProvider = ({ children }) => {
  const [financialData, setFinanicalData] = useState();
  const financialDetailCollectData = (data) => {

    setFinanicalData(data);
  };

  return (
    <FinancialDetailsContext.Provider value={{ financialData, financialDetailCollectData }}>
      {children}
    </FinancialDetailsContext.Provider>
  );
};
export default FinancialDetailsProvider;
